import React from 'react';
import { Container } from 'react-bootstrap';
import './slider.css';

const Slider = () => {
  // Using placeholder images for the logos based on the image provided.
  // Replace the 'image' property with actual imported logo files (e.g., import sailLogo from '../../assets/sail.png')
  const logos = [
    { id: 1, name: 'AFCONS', image: './images/company-logo/afcons.png' },
    { id: 2, name: 'BNC Enterprise', image: './images/company-logo/bnc.png' },
    { id: 3, name: 'Ministry of water & irrigation, Tanzania', image: './images/company-logo/coat.png' },
    { id: 4, name: 'Ontario industrial component solution', image: './images/company-logo/oics.png' },
    { id: 5, name: 'Shapoorji Pallonji Group', image: './images/company-logo/shapoorji.png' },
    { id: 6, name: 'Ministry of health-Sychelles', image: './images/company-logo/health.png' },
    { id: 7, name: 'Shell Eastern Petroleum', image: './images/company-logo/shell.png' },
    { id: 8, name: 'Arvind Envisol Ltd', image: './images/company-logo/envisol.png' },
  ];

  return (
    <section className="logo-slider-section">
      <Container fluid>
        <h2 className="logo-slider-heading">Our Clients</h2>
        
        <div className="logo-slider-container">
          <div className="logo-track">
            {/* Render the logos array twice to create an infinite seamless loop effect */}
            {[...logos, ...logos].map((logo, index) => (
              <div className="logo-item" key={`${logo.id}-${index}`}>
                <img 
                  src={logo.image} 
                  alt={logo.name} 
                  className="logo-image"
                />
                {/* Tooltip-style company name revealed on hover */}
                <span className="logo-name">{logo.name}</span>
              </div>
            ))}
          </div>
        </div>
      </Container>
    </section>
  );
};

export default Slider;
